"use strict";
const _ = require("lodash");
const BaseMultipleOptionSelectionControlComponent = require("@gluenetworks/input_base_control")
    .OptionSelection.Multiple;
const Renderer = require("./MultipleSelectListControlRenderer");

class MultipleSelectListControlComponent extends BaseMultipleOptionSelectionControlComponent {
    /**
     * @schema.name Multiple Select List Control
     * @schema.package @gluenetworks/select_list
     * @schema.packageIdentifier Multiple
     * @schema.namespace require("@gluenetworks/steve_ui_core").Control.OptionSelection.Multiple.SelectList
     * @schema.events ["Options", "Disabled", "Value", "Visible", "Invalid", "DarkTheme", "Focus", "Blur", "SetAttribute", "UserValue", "UserFocus", "UserBlur", "UserKeyDown"]
     *
     * @schema.configuration.options.example [{ label: 'Number 1', value: { valueProp1: 'blah1', valueProp2: { somethin: 'somethin1' } }, disabled: true },{ label: 'Number 2', value: { valueProp1: 'blah2', valueProp2: { somethin: 'somethin2' } } },{ label: 'Number 3', value: { valueProp1: 'blah3', valueProp2: { somethin: 'somethin3' } }, disabled: true },{ label: 'Number 4', value: { valueProp1: 'blah4', valueProp2: { somethin: 'somethin4' } } },{ label: 'Number 5', value: { valueProp1: 'blah5', valueProp2: { somethin: 'somethin5' } } },{ label: 'Number 6', value: { valueProp1: 'blah6', valueProp2: { somethin: 'somethin6' } } },{ label: 'Number 7', value: { valueProp1: 'blah7', valueProp2: { somethin: 'somethin7' } } }]
     *
     * @schema.configuration.value.example [{ valueProp1: 'blah1', valueProp2: { somethin: 'somethin1' } },{ valueProp1: 'blah2', valueProp2: { somethin: 'somethin2' } }]
     *
     */

    constructor(configOptions) {
        super(configOptions);
        this._optionIcon = _.get(configOptions, "optionIcon", false);
        this._selectedOptionIcon = _.get(configOptions, "selectedOptionIcon", false);
        this._comboBoxMode = _.get(configOptions, "comboBoxMode", false);

        this._createRenderer(configOptions);
        this._registerListeners();
    }

    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS   */
    /*******************************************/

    _createRenderer(/*configOptions*/) {
        this._renderer = new Renderer(this);
    }

    _registerListeners() {}

    _unregisterListeners() {}

    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS.    */
    /* START PUBLIC COMPONENT MODEL METHODS.   */
    /*******************************************/

    get isComboBoxMode() {
        return this._comboBoxMode;
    }

    hasOptionIcons() {
        return _.isString(this._optionIcon) || _.isFunction(this._optionIcon);
    }

    getOptionIcon(optionValue) {
        let isSelected = this._value.includes(optionValue);
        if (isSelected) {
            return this.getSelectedOptionIcon(optionValue);
        }
        if (_.isString(this._optionIcon)) {
            return this._optionIcon;
        } else if (_.isFunction(this._optionIcon)) {
            return this._optionIcon(optionValue);
        } else {
            return "common.check";
        }
    }

    getSelectedOptionIcon(optionValue) {
        if (_.isString(this._selectedOptionIcon)) {
            return this._selectedOptionIcon;
        } else if (_.isFunction(this._selectedOptionIcon)) {
            return this._selectedOptionIcon(optionValue);
        } else {
            return "common.check";
        }
    }

    get renderer() {
        return this.getRenderer();
    }

    getRenderer() {
        return this._renderer;
    }

    shutdown() {
        this._unregisterListeners();
        let prom = this._renderer._shutdown();
        this._renderer = undefined;
        this._options = undefined;
        this._disabled = undefined;
        this._invalid = undefined;
        this._visible = undefined;
        this._value = undefined;
        this._darkTheme = undefined;
        this.theme = undefined;
        this._userSelected = undefined;
        return prom;
    }

    /*******************************************/
    /* END COMPONENT MODEL METHODS             */
    /* START HANDLER METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS                     */
    /* START PRIVATE METHODS                   */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS                     */
    /* START PUBLIC API METHODS                */
    /*******************************************/

    /**
     * @schema.methods.setLastSelected.name setLastSelected
     * @schema.methods.setLastSelected.description Sets the last selected value and returns an instance of the control for chainability
     * @schema.methods.setLastSelected.returns Instance of the control
     * @schema.methods.setLastSelected.parameters.newVal.name newVal
     * @schema.methods.setLastSelected.parameters.newVal.description The new option text
     * @schema.methods.setLastSelected.parameters.newVal.type object
     */
    setLastSelected(newVal) {
        this._lastSelected = newVal;
        this.emit("LastSelected", this._lastSelected);
        return this;
    }

    /**
     * @schema.methods.setLastSelected.name setLastSelected
     * @schema.methods.setLastSelected.description Sets the last selected value and returns an instance of the control for chainability
     * @schema.methods.setLastSelected.returns Instance of the control
     * @schema.methods.setLastSelected.parameters.newVal.name newVal
     * @schema.methods.setLastSelected.parameters.newVal.description The new option text
     * @schema.methods.setLastSelected.parameters.newVal.type object
     */
    clearLastSelected() {
        this.setLastSelected(undefined);
        return this;
    }

    /**
     * @schema.methods.getLastSelected.name getLastSelected
     * @schema.methods.getLastSelected.description Returns the option label text
     * @schema.methods.getLastSelected.returns string
     */
    getLastSelected() {
        return this._lastSelected;
    }

    get lastSelected() {
        return this.getLastSelected();
    }

    set lastSelected(newVal) {
        this.setLastSelected(newVal);
    }

    /*******************************************/
    /* END PUBLIC API METHODS                  */
    /*******************************************/
}
module.exports = MultipleSelectListControlComponent;
